import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Input, Label } from "reactstrap";
import MessageFormValidateV2 from "../MessageFormValidateV2";

/**
 * @param {{
 *  mainForm: any;
 *  fieldName: string;
 *  t: TranslationFunc;
 *  isDisabled: boolean;
 *  isRequired: boolean;
 *  title: string;
 *  isLabel: boolean;
 *  isPlaintext: boolean;
 *  onChange: (val?: any) => void;
 *  cssInput: Record<string, any>;
 *  dataList:object[]
 * }} props
 */
const FormRadio = props => {
  const {
    mainForm,
    fieldName,
    t,
    isDisabled,
    isRequired,
    title,
    isLabel,
    isPlaintext,
    onChange,
    cssInput,
    dataList,
  } = props;

  /** @type {import("react-hook-form").UseFormReturn} */
  const {
    formState: { errors, touchedFields },
    control,
    setValue,
    watch,
  } = mainForm;

  const dataFieldName = watch(fieldName);

  return (
    <React.Fragment>
      <div className={`${isLabel ? "mb-3" : ""}`}>
        {isLabel && (
          <Label htmlFor={fieldName}>
            {title || t(`form.${fieldName}`)}{" "}
            {isRequired && <span className="text-danger">*</span>}
          </Label>
        )}
        <div>
          <Controller
            name={fieldName}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <div className="d-flex gap-2">
                {dataList?.map(d => {
                  return (
                    <FormGroup key={d?.value} check>
                      <Label check>
                        <Input
                          {...field}
                          disabled={isDisabled}
                          type="radio"
                          value={d?.value}
                          checked={dataFieldName?.value === d?.value}
                          onChange={() => {
                            setValue(fieldName, d);
                          }}
                        />
                        {d?.label}
                      </Label>
                    </FormGroup>
                  );
                })}
              </div>
            )}
          />
        </div>

        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      </div>
    </React.Fragment>
  );
};

FormRadio.propTypes = {
  mainForm: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  title: PropTypes.string,
  isLabel: PropTypes.bool,
  isPlaintext: PropTypes.bool,
  onChange: PropTypes.func,
  isInputGroup: PropTypes.bool,
  elmGroupAfter: PropTypes.element,
  cssInput: PropTypes.object,
};

FormRadio.defaultProps = {
  isDisabled: false,
  isRequired: false,
  title: "",
  isLabel: true,
  isPlaintext: false,
  onChange: () => {},
  cssInput: {},
};

export default FormRadio;
